module.exports = __webpack_public_path__ + "static/forms2-bf429c28482e815bf1322a0c6a496899.jpg";